<template>
    <div v-show="showTopOptions" id="top-options-container">
        <div class="top-options__middle" v-show="activeImageId">
            <ImportMedia v-if="activeImageId" />
        </div>

        <div class="top-options__left" v-show="activeImageId">
        </div>

        <div class="top-options__right justify-end" v-show="activeImageId">
            <div class="d-flex" style="margin: 0 7px; gap: 14px" name="download-buttons-group">
                <v-menu
                        v-if="!isGuest"
                        :content-class="'file-tags-menu-container'"
                        :disabled="(!canExportLUT) || blockLoading"
                        :nudge-bottom="8"
                        offset-y
                >
                    <template v-slot:activator="{ on, attrs }">
                        <div v-bind="attrs" v-on="on"
                             name="download-menu-btn"
                             @click="openDownloadMenu"
                             :class="{'--disabled': (!canExportLUT) || blockLoading }">
                            <i v-tippy class="material-icons" content="Download">save_alt</i>
                            <i class="material-icons dropdown-icon">arrow_drop_down</i>
                        </div>
                    </template>
                    <v-list>
                        <v-list-item @click="downloadLUT()" :disabled="!canExportLUT">
                            <i class="material-icons">save_alt</i>
                            <v-list-item-title>Download a LUT</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>

                <div class="btn-export-image control-name"
                     @click="openDownloadMenu"
                     v-tippy content="Save Image"
                >
                    <i class="material-icons">photo</i>
                    <i class="material-icons dropdown-icon">arrow_drop_down</i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import CanMixin from '@/mixins/CanMixin';
import FilenameMixin from '@/mixins/Filename';
import ImportMedia from '@/components/app/buttons/ImportMedia.vue';

export default {
    name: 'TopOptions',
    components: { ImportMedia },
    mixins: [CanMixin, FilenameMixin],

    computed: {
        ...mapState('App', ['IDT', 'blockLoading']),
        ...mapState('File/Media', ['tags']),
        ...mapState('UI', ['startTipsStep', 'showAddMatchTooltip']),
        ...mapState('File/Media', {
            currentFile: 'active'
        }),
        ...mapState('Projects', {
            activeImageId: 'image',
        }),

        ...mapGetters('Projects', ['isCurrentFileShared']),
        ...mapGetters('User', ['isGuest']),
        ...mapGetters('UI', ['filteredCandidates']),

        showTopOptions() {
            return true;
        },
    },
    methods: {
        openDownloadMenu() {
            if (this.startTipsStep == 6) this.$store.dispatch('UI/setStartTipsStep', 'completed');
        },

        downloadLUT() {
            if (!this.$store.state.Projects.image) return;
            if (!this.canExportLUT) return;

            window.UI.showModal(window.UI.modals.exportLut.el);
        },

    }
};
</script>

<style lang="scss">
//PLEASE, DO NOT REMOVE THIS LINE!
//DISCLAIMER: When building for production, some CSS for top-options
//is missing. Placing this dummy class below fixed the issue. WTF? yeah...
.dummy-placeholder {
	color: black;
}

#btn-add-candidate {
	cursor: pointer;
    position: absolute;
    left: 40px;
    top: 50%;
    transform: translateY(-50%);
}

.top-options {
	&__left, &__middle, &__right {
		display: flex;

		.group-separator {
			width: 2px;
			height: 30px;
			background-color: var(--color-group-separator);
			margin: 0 10px;
		}
	}
}

.top-options__middle {
	> * {
		margin: 0 7px;
	}

	> i + div {
		margin: 0;
	}
}

#top-options-container {
	grid-area: top;
	position: relative;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 0 40px;
	font-size: 12px;
	background-color: var(--color-bg-dark);
	border-bottom: 2px solid var(--color-bg-gray-2);

	div.disabled {
		i {
			cursor: not-allowed;
		}
	}

	.v-icon {
		color: var(--font-color-default) !important;
		font-size: 18px;
	}

	i {
		color: #989898;
		font-size: 18px;
		width: 18px;
		cursor: pointer;

		&.dropdown-icon {
			margin-left: -3px;
			margin-right: -5px;
		}
	}
}

.file-tags-menu-container {
	border-radius: var(--box-rounding);
	min-width: initial !important;

	&.--rating {
		.v-list-item {
			display: flex !important;
			align-items: center;
		}

		.v-list-item__title {
			margin-left: 0 !important;
		}
	}

	.v-list {
		background: var(--dark-gray);
		padding: 25px 0;
		position: relative;
		display: flex;
		flex-direction: column;

		.v-list-item {
			min-height: 20px;
			padding: 0 25px;
			display: grid;
			grid-template-columns: 18px 1fr 18px;
			cursor: pointer;

			&--link:before {
				display: none !important;
			}

			&.--first {
				order: -1;
			}

			&:hover {
				background: rgb(54, 54, 54);
			}

			&.full-span {
				grid-template-columns: 1fr;
			}

			&.stars-icons-container {
				grid-template-columns: repeat(5, 1fr);
			}

			&[aria-expanded="true"] {
				background: rgb(54, 54, 54);
			}

			&.--selected {
				.material-icons,
				.v-list-item__title {
					color: var(--primary);
				}
			}

			&.v-list-item--disabled {
				opacity: 0.6;
			}

			.material-icons {
				color: #989898;
				font-size: 18px;
				width: 18px;
			}

			.v-list-item__title {
				margin-left: 4px;
				color: #989898;
				font-size: 1rem;
			}

			&:after {
				display: none;
			}
		}
	}
}
</style>
